export default __webpack_public_path__ + "static/media/icon-dashboard-3.4831d9d9.svg";